import { useState } from 'react';

/**
 * Offseg遷移メニューの状態管理用カスタムフック
 */
export const useStateOffsegMenu = () => {
	const [anchorElOffsegMenu, setAnchorElOffsegMenu] = useState<null | HTMLElement>(null); // ポップアップメニューの開閉状態を管理
	const openOffsegMenu = Boolean(anchorElOffsegMenu);

	const handleOpenOffsegMenu = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorElOffsegMenu(event.currentTarget);
	};

	const handleCloseOffsegMenu = () => {
		setAnchorElOffsegMenu(null);
	};

	return {
		anchorElOffsegMenu,
		openOffsegMenu,
		handleOpenOffsegMenu,
		handleCloseOffsegMenu,
	};
};
